import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Brand } from "./Brand";
import { Button } from "./ui/button";
import { LogOut } from "lucide-react";
import { clearUser, getUser } from "../lib/auth";

export const Header = () => {
  const navigate = useNavigate();
  const user = getUser();

  const handleLogout = () => {
    clearUser();
    navigate("/");
  };

  const linkClass = ({ isActive }) =>
    `relative py-2 text-sm font-medium tracking-wide transition-colors duration-200 ${
      isActive ? "text-slate-900" : "text-slate-500 hover:text-slate-900"
    }`;

  return (
    <header
      className="sticky top-0 z-40 w-full border-b border-slate-200 bg-white/85 backdrop-blur-md"
      data-testid="app-header"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-6 px-4 py-4 sm:px-6 lg:px-8">
        <Link to="/" data-testid="header-brand-link">
          <Brand variant="dark" size="md" />
        </Link>

        {user && (
          <nav className="hidden items-center gap-8 md:flex">
            <NavLink to="/marketplace" className={linkClass} data-testid="nav-marketplace">
              {({ isActive }) => (
                <>
                  Marketplace
                  {isActive && <span className="absolute -bottom-[1px] left-0 h-[2px] w-full bg-[#D4AF37]" />}
                </>
              )}
            </NavLink>
            <NavLink to="/portfolio" className={linkClass} data-testid="nav-portfolio">
              {({ isActive }) => (
                <>
                  Portfolio
                  {isActive && <span className="absolute -bottom-[1px] left-0 h-[2px] w-full bg-[#D4AF37]" />}
                </>
              )}
            </NavLink>
          </nav>
        )}

        <div className="flex items-center gap-4">
          {user ? (
            <>
              <div className="hidden text-right sm:block">
                <div className="overline">Investor</div>
                <div className="text-sm font-medium text-slate-800 font-mono-num" data-testid="header-user-email">{user.email}</div>
              </div>
              <Button
                variant="outline"
                size="sm"
                onClick={handleLogout}
                data-testid="header-logout-btn"
                className="border-slate-300 text-slate-700 hover:bg-slate-50"
              >
                <LogOut className="mr-2 h-4 w-4" /> Sign out
              </Button>
            </>
          ) : (
            <span className="overline">Institutional Portal</span>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
